import { BundleProps } from 'utils/types';
import { EBadgeType, ESpecialOfferInternalViewModel } from 'utils/enums';
import { StyledBanditos } from './styles';
import { BadgeData, IRibbonBadge } from 'components/Badge/types';
import { SpecialOfferProps } from 'templates/SpecialOffer/types';
import { BundlePrice } from 'components/BundlePrice';
import { AutoTextSize } from 'utils/autoTextSizeUtils';
import { useGetBadge } from 'utils/useGetBadge';
import { useEffect, useState } from 'react';
import ribbonImageBadge from 'assets/Banditos/banditos-ribbon.png';

interface IBanditosTemplateProps {
  prices: BundleProps['prices'];
  productList: BundleProps['productList'];
  backgroundSrc: BundleProps['backgroundSrc'];
  backgroundColor: BundleProps['backgroundColor'];
  ribbonBadges: BundleProps['ribbonBadges'];
  selectOffer?: SpecialOfferProps['selectOffer'];
  dataTestId?: string;
  isFree?: boolean;
  availability?: {
    total: number;
    remaining: number;
  };
  timer?: string;
  className?: string;
  badges?: BadgeData[];
  inMobileMock?: boolean;
  offerDescription?: string;
  collectText?: string;
}

export const BanditosTemplate: React.FC<IBanditosTemplateProps> = ({
  prices,
  dataTestId,
  productList,
  backgroundSrc,
  backgroundColor = {
    colorOne: '#E2AE54',
  },
  selectOffer,
  isFree,
  badges = [],
  availability,
  timer,
  className,
  inMobileMock = false,
  offerDescription,
  collectText = 'Collect',
  ribbonBadges = [],
}) => {
  const [ribbonBadgeOld, setRibbonBadgeOld] = useState<any>(null);
  const ribbonBadgeNew = useGetBadge<IRibbonBadge>(ribbonBadges);

  useEffect(() => {
    let foundRibbon;
    if (badges.length > 0) {
      if (badges[0].badge) {
        foundRibbon = badges?.find(
          (badge: BadgeData) =>
            (badge as BadgeData).badge?.type === EBadgeType.RIBBON,
        )?.badge as BadgeData;
        setRibbonBadgeOld(foundRibbon?.ribbon);
      } else {
        foundRibbon = badges?.find(
          (badge: BadgeData) => badge.type === EBadgeType.RIBBON,
        );
        setRibbonBadgeOld(foundRibbon?.ribbon);
      }
    }
  }, [badges]);

  const ribbonBadge = ribbonBadgeNew ?? ribbonBadgeOld;

  return (
    <StyledBanditos
      backgroundSrc={backgroundSrc}
      backgroundColor={backgroundColor}
      inMobileMock={inMobileMock}
      ribbonBadge={ribbonImageBadge}
      onClick={selectOffer}
      data-testid={dataTestId}
    >
      <div className="container">
        {ribbonBadge?.text && (
          <div className="ribbon-badge">
            <div className="ribbon-badge-text">
              <AutoTextSize
                maxFontSizePx={18}
                minFontSizePx={4}
                mode="oneline"
                style={{ color: ribbonBadge?.textColor || '#fff' }}
              >
                {ribbonBadge?.text}
              </AutoTextSize>
            </div>
          </div>
        )}
        {offerDescription && <div className="title">{offerDescription}</div>}
        {timer && <div className="timer">Ends in: {timer}</div>}
        {availability && (
          <div className="availability">
            {availability?.remaining}/{availability?.total}
          </div>
        )}
        {productList.length > 0 && (
          <div className="products">
            {productList.map((product) => (
              <div
                className="product"
                style={{
                  paddingBottom: product.strokedSaleQuantity ? '1px' : '5px',
                }}
              >
                <img src={product.images.product} alt={product.displayName} />
                <div className="quantity">
                  <AutoTextSize
                    maxFontSizePx={16}
                    minFontSizePx={4}
                    mode="oneline"
                    style={{ color: product.textFontColorHex || '#fff' }}
                  >
                    {product.quantityDisplay}
                  </AutoTextSize>
                </div>
                {product.strokedSaleQuantity && (
                  <div className="stroked">
                    <AutoTextSize
                      maxFontSizePx={14}
                      minFontSizePx={4}
                      mode="oneline"
                    >
                      {product.strokedSaleQuantity}
                    </AutoTextSize>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
        <BundlePrice
          prices={prices}
          type={ESpecialOfferInternalViewModel.BANDITOS}
          isFree={isFree}
          buttonText={collectText}
          isTextAutoResized
        />
      </div>
    </StyledBanditos>
  );
};
